export default "__VITE_ASSET__d1d526c3__"